export const ChronoIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="250"
    height="264"
    viewBox="0 0 250 264"
  >
    <g data-name="Chrono icon">
      <path
        data-name="Tracé 63"
        d="M96.01 182.329a107.8 107.8 0 0 1-53.7-14.32l.237-.407a107.4 107.4 0 0 0 53.463 14.254c58.972 0 106.948-47.7 106.948-106.332S154.982-30.808 96.01-30.808A107.367 107.367 0 0 0 42.545-16.55l-.237-.41a107.833 107.833 0 0 1 53.7-14.32c59.233 0 107.423 47.912 107.423 106.8S155.244 182.329 96.01 182.329zm12.248-213.373h-24.5v-18.268h24.5zm9.188-18.268H74.575a3.053 3.053 0 0 1-3.064-3.044v-18.271a3.053 3.053 0 0 1 3.064-3.044h42.871a3.053 3.053 0 0 1 3.064 3.044v18.271a3.053 3.053 0 0 1-3.064 3.044zm-10.608 135.6a15.376 15.376 0 0 1-21.656 0 15.161 15.161 0 0 1 0-21.531c3.793-3.77 28.718-19.894 46.452-31.194a4.747 4.747 0 0 1 6.578 6.54c-11.362 17.637-27.584 42.416-31.374 46.186zm71.628-105.66a.235.235 0 0 0-.335 0 .228.228 0 0 0 0 .33l6.326 6.293L171.634 0a.232.232 0 0 0 0 .334.235.235 0 0 0 .167.07.248.248 0 0 0 .167-.07l12.824-12.753 6.33 6.293a.248.248 0 0 0 .167.069.236.236 0 0 0 .167-.069.232.232 0 0 0 0-.334zm-82.218-2.2h-.475v-9.473h.475zm0 203.664h-.475v-9.472h.475zm48.8-190.536-.415-.24 4.763-8.2.415.24zM180.7 27.181l-.237-.407 8.249-4.736.237.407zm22.5 48.579h-9.53v-.473h9.53zm-14.481 53.253-8.249-4.736.237-.407 8.249 4.736zM149.4 167.936l-4.763-8.2.415-.24 4.763 8.2zM32.9 75.76h-71.467v-.473H32.9zm0-23.682h-52.411v-.473H32.9zm0-23.682H-.455v-.473H32.9zm0-23.681H18.6v-.472h14.3zm0 94.726h-52.411v-.473H32.9zm0 23.681H-.455v-.473H32.9zm0 23.682H18.6v-.473h14.3z"
        transform="translate(42.567 77.671)"
        fill={"none"}
        stroke={"#f2f4f8"}
        strokeLinecap={"round"}
        strokeLinejoin={"round"}
        strokeWidth={"8px"}
      />
    </g>
  </svg>
);
